module.exports = __webpack_public_path__ + "media/images/logo08_24b-bed3b21dc0cf4652a7e02e43854a8258.png";